export default "__VITE_ASSET__D39e4AzT__"